"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "renderToastContainer_unstable", {
    enumerable: true,
    get: function() {
        return renderToastContainer_unstable;
    }
});
const _jsxruntime = require("@fluentui/react-jsx-runtime/jsx-runtime");
const _reactutilities = require("@fluentui/react-utilities");
const _reacttransitiongroup = require("react-transition-group");
const _toastContainerContext = require("../../contexts/toastContainerContext");
const renderToastContainer_unstable = (state, contextValues)=>{
    const { onTransitionEntering, visible, transitionTimeout, remove, nodeRef } = state;
    (0, _reactutilities.assertSlots)(state);
    return /*#__PURE__*/ (0, _jsxruntime.jsx)(_reacttransitiongroup.Transition, {
        in: visible,
        appear: true,
        unmountOnExit: true,
        timeout: transitionTimeout,
        onExited: remove,
        onEntering: onTransitionEntering,
        nodeRef: nodeRef,
        children: /*#__PURE__*/ (0, _jsxruntime.jsxs)(_toastContainerContext.ToastContainerContextProvider, {
            value: contextValues.toast,
            children: [
                /*#__PURE__*/ (0, _jsxruntime.jsx)(state.root, {}),
                /*#__PURE__*/ (0, _jsxruntime.jsx)(state.timer, {})
            ]
        })
    });
};
